/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { createContext, useState, useContext } from 'react';
import { IonAlert } from '@ionic/react';
const store = createContext({ state: {}, setState: () => null });
const { Provider } = store;
const AlertProvider = (props) => {
    const [state, setState] = useState({});
    return React.createElement(Provider, { value: { state, setState } },
        React.createElement(IonAlert, { isOpen: state.show || false, onDidDismiss: () => setState(Object.assign(Object.assign({}, state), { show: false })), header: state.header || '', message: state.body || '', buttons: state.buttons || [], cssClass: state.cssClass }),
        props.children);
};
function useAlert() {
    const alertContext = useContext(store);
    const showAlert = (props) => {
        alertContext.setState(Object.assign(Object.assign({}, props), { show: true }));
    };
    const hideAlert = () => {
        alertContext.setState(Object.assign(Object.assign({}, alertContext.state), { show: false }));
    };
    return {
        showAlert: showAlert,
        hideAlert: hideAlert
    };
}
export { store as AlertStore, AlertProvider, useAlert };
//# sourceMappingURL=index.js.map